import React from 'react';
// import PropTypes from 'prop-types';
import $ from 'jquery'
import Isotope from "isotope-layout/js/isotope";
import Layout from '../../components/layout'
import Form from '../../components/Form'
import '../../styles/pages/campaign.css'

const propTypes = {};

const defaultProps = {};

export default class campaignAnalysis extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount(){
    $('.control').click(function(){
        $('.control').removeClass('filtr-active');
        $(this).addClass('filtr-active');
    });  
    }

    // Click Function
  onFilterChange = (newFilter) => {
    if (this.iso === undefined) {
      this.iso = new Isotope('#filter-container', {
        itemSelector: '.filtr-item',
      });
    }
    if(newFilter === '*') {
      this.iso.arrange({ filter: `*` });
    } else {
      this.iso.arrange({ filter: `#${newFilter}` });
    }
  }
  
  
  render() {
    return (
      <Layout>
        <div class="page-wrapper">
      <div class="fullscreen bg15 " data-scroll-index="0">
        <div class="grediant-overlay opacity-4"></div>
        <div class="center-col  white-text" id="home">
          <div class="container">
            <div class="row">
              <div
                class="col-md-10 col-lg-8"
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="500"
              >
                <div class="home-content">
                  <h1 class="large-heading">
                    <span class="font-weight-extralight" >
                      Do you want to stand out from the crowd with data driven insights for your campaigns ?
                    </span>
                    <br />
                  </h1>
                </div>
                <div class="section-header pt-50">
                  <h4>
                      Augment your team with the best, brightest data and media experts
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        
      </div>

              <section class="section-spacer" data-scroll-index="1" data-aos="fade" data-aos-duration="400">
                  <div class="container">
                      <div class="section-header">
                          <h2>What We Do</h2>
                      </div>
                      <div class="work-list">
                          <ul class="work-nav list-unstyled filter-button-group">
                              <li><a href="javascript:void(0)" class="control filtr-active" data-filter="*" onClick={() => {this.onFilterChange("*")}}>All</a></li>
                              <li><a href="javascript:void(0)" class="control" data-filter="media" onClick={() => {this.onFilterChange("media")}}>Media Analytics</a></li>
                              <li><a href="javascript:void(0)" class="control" data-filter="customer" onClick={() => {this.onFilterChange("customer")}}>Customer Analytics</a></li>
                              <li><a href="javascript:void(0)" class="control" data-filter="campaign" onClick={() => {this.onFilterChange("campaign")}}>Campaign Analytics</a></li>

                          </ul>
                          <div id="filter-container" class="filtr-container row">
                              <div class="filtr-item mh180" id="media" data-index="1">
                                  <div class="our-step">
                                      <div class="step-number font15 text-grediant lhn mb-3">
                                          Text analytics
                                      </div>
                                      <p>Help you understand how people perceive your brand</p>
                                  </div>
                              </div>
                              <div class="filtr-item mh180" id="media" data-index="2">
                                  <div class="our-step">
                                      <div class="step-number font15 text-grediant lhn mb-3">
                                          Marketing spend optimization
                                      </div>
                                      <p>Attribute and optimize media spends to different channels.</p>
                                  </div>
                              </div>
                              <div class="filtr-item mh180" id="media" data-index="3">
                                  <div class="our-step">
                                      <div class="step-number font15 text-grediant lhn mb-3">
                                          Path Analysis
                                      </div>
                                      <p>Find ideal conversion path to inform ad purchasing or Go-To-Market behaviours.</p>
                                  </div>
                              </div>
                              <div class="filtr-item mh180" id="media" data-index="4">
                                  <div class="our-step">
                                      <div class="step-number font15 text-grediant lhn mb-3">
                                          Audience Analysis
                                      </div>
                                      <p>Link user conversion affinities with their interests across products &amp; geographies for improved planning and targeting.</p>
                                  </div>
                              </div>
                              <div class="filtr-item mh180 shuffle-item" id="customer" data-index="5">
                                  <div class="our-step">
                                      <div class="step-number font15 text-grediant lhn mb-3">
                                          Churn Prediction
                                      </div>
                                      <p>Help predict the probability of churn to competition using customer’s online activities</p>
                                  </div>
                              </div>
                              <div class="filtr-item mh180" id="customer" data-index="6">
                                  <div class="our-step">
                                      <div class="step-number font15 text-grediant lhn mb-3">
                                          Customer Lifetime Value Prediction
                                      </div>
                                      <p>Answer the question regarding the quality of customers we are acquiring through various digital channels</p>
                                  </div>
                              </div>
                              <div class="filtr-item mh180" id="campaign" data-index="7">
                                  <div class="our-step">
                                      <div class="step-number font15 text-grediant lhn mb-3">
                                          Match Market
                                      </div>
                                      <p>Test to create exposed and controlled to understand campaign efficacy</p>
                                  </div>
                                </div>
                                <div class="filtr-item mh180" id="campaign" data-index="8">
                                    <div class="our-step">
                                        <div class="step-number font15 text-grediant lhn mb-3">
                                            Optimize
                                        </div>
                                        <p>Efficiently plan the campaign across weekday time-slots, geographies and creatives</p>
                                    </div>
                                </div>
                                <div class="filtr-item mh180" id="campaign" data-index="9">
                                    <div class="our-step">
                                        <div class="step-number font15 text-grediant lhn mb-3">
                                            Performance Analysis & KPI 
                                        </div>
                                        <p>Forecasting for campaigns which needs urgent attention</p>
                                    </div>
                                </div>
                                <div class="filtr-item mh180" id="customer" data-index="10">
                                    <div class="our-step">
                                        <div class="step-number font15 text-grediant lhn mb-3">
                                            Cross Sell / Up Sell
                                        </div>
                                        <p>Analyse customer’s requirement through digital trends to expand portfolio</p>
                                    </div>
                                </div>
                                
                                <div class="filtr-item mh180" id="media" data-index="11">
                                    <div class="our-step">
                                        <div class="step-number font15 text-grediant lhn mb-3">
                                            Video Ads Analytics
                                        </div>
                                        <p>Connect video watch-time with conversion on app</p>
                                    </div>
                                </div>
                                <div class="filtr-item mh180" id="media" data-index="12">
                                    <div class="our-step">
                                        <div class="step-number font15 text-grediant lhn mb-3">
                                            Reach and Frequency
                                        </div>
                                        <p>Get unique users reached via a campaign using multiple channels i.e. Admob, Youtube, etc.</p>
                                    </div>
                                </div>
                                <div class="filtr-item mh180" id="customer" style={{left:"0px !important"}} data-index="13">
                                    <div class="our-step">
                                        <div class="step-number font15 text-grediant lhn mb-3">
                                            Customer Profiling
                                        </div>
                                        <p>Segment website traffic (customers) to understand mix & strategize digital acquisition</p>
                                    </div>
                                </div>

                          </div>
                      </div>
                  </div>
              </section>
      <section class="contact-us-form theme-1 section-spacer" data-scroll-index="0">
        <div class="container">
            <div class="section-header">
                <h2>Get in touch</h2>
            </div>
           <Form />
        </div>
    </section>
      </div>
      </Layout>
    );
  }
}

 campaignAnalysis.propTypes = propTypes;
 campaignAnalysis.defaultProps = defaultProps;